module.exports = __webpack_public_path__ + "static/Xbot-15a733e3a5c533da3b5f3841e76d0d08.png";